module.exports = __webpack_public_path__ + "static/media/call8.9fb5382b.png";